import React, { useCallback, useEffect } from 'react'
import ReactMarkdown, { uriTransformer } from 'react-markdown'

import mermaid from 'mermaid'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import { rehypeCustomAnchor, rehypeCustomMermaid } from './rehypeCustomPlugins'
import transformDocLink from './transformDocLink'

import './index.css'

const MarkdownRenderer = ({ markdownText, baseRoute }) => {
  useEffect(() => {
    mermaid.initialize({
      startOnLoad: true,
      theme: 'default',
    })
  }, [])

  useEffect(() => {
    mermaid.contentLoaded()
  }, [markdownText])

  const transformLinkUri = useCallback(
    (href) => transformDocLink(uriTransformer(href), baseRoute),
    [baseRoute],
  )

  return (
    <div className='markdown-renderer'>
      <ReactMarkdown
        children={markdownText}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeCustomAnchor, rehypeCustomMermaid]}
        transformLinkUri={transformLinkUri}
      />
    </div>
  )
}

export default MarkdownRenderer
